<template>
  <div v-bind:class="{ 'datavis black': this.black, 'datavis white': !this.black }">

    <span class="grid__number hundred">{{maxNumber}} MENTIONS</span>
    <span class="grid__number fifty">{{maxNumber/2}}</span>

    <svg class="grid" width="100%" height="100px" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <line stroke-dasharray="1, 5" x1="0" y1="1%" x2="100%" y2="1%"></line>
      <line stroke-dasharray="1, 5" x1="0" y1="25%" x2="100%" y2="25%"></line>
      <line stroke-dasharray="1, 5" x1="0" y1="50%" x2="100%" y2="50%"></line>
      <line stroke-dasharray="1, 5" x1="0" y1="75%" x2="100%" y2="75%"></line>
    </svg>

    <div class="graph__meta" :style="'width:' + width + 'px'">
      <span class="graph__metadetail" :style="'left:' + metaData.x + 'px'" v-if="metaData.show">{{metaData.hits}} – {{ metaData.date }}</span>
    </div>
    <svg class="graph" viewbox="0 0 600 150" :width="width + 'px'" height="150px">

    <g v-for="(graph, index) in graphdata.buckets" :key="graph.key" :class="'bars '+ index">
      <rect :ref="'bars_' + index" @mouseover="showMeta(index, graph.doc_count, graph.key)" @mouseout="metaData.show=false" @click="filterYears(graph.key)" v-bind="{ 'x':index*10, 'y':150-(maxNumberRelative * graph.doc_count)}" width="6" :height="maxNumberRelative * graph.doc_count + 'px'"/>
    </g>
    </svg>

  </div>
</template>

<script>
import anime from 'animejs'

export default {
  name: 'datavis',
  data: function () {
    return {
      width: 0,
      metaData: {
        show: false,
        date: '',
        hits: 0,
        x: 0
      },
      maxNumber: 0,
      maxNumberRelative: 0
    }
  },
  props: ['graphdata', 'black'],
  methods: {
    findMax: function () {
      // Math.max()
      // console.log('nix')
      var data = []
      this.graphdata.buckets.map(period =>
        // console.log(x.doc_count)
        data.push(period.doc_count)
      )
      // console.log('max')
      // console.log(data)

      this.maxNumber = Math.max(...data)
      this.width = data.length * 10
      this.maxNumberRelative = 100 / Math.max(...data)
    },
    filterYears: function (time) {
      // console.log(time)
      this.$emit('clicked', time)
    },
    generateYears: function () {
      // console.log('jaren separeren en een tijdtable maken')
    },
    showMeta: function (index, docs, time) {
      // console.log(index)
      this.metaData.show = true
      var leftMargin = this.$refs['bars_' + index][0].x.animVal.value
      // console.log('left margin ', leftMargin)
      this.metaData.x = leftMargin
      this.metaData.hits = docs
      this.metaData.date = this.formatTime(time)
      // console.log(docs)
    },
    formatTime (time) {
      var tijdstipTemp = new Date(time)

      var thisDate = tijdstipTemp
      var mm = thisDate.getMonth() + 1

      var yyyy = thisDate.getFullYear()
      if (mm < 10) {
        mm = '0' + mm
      }
      return mm + '.' + yyyy
    }
  },
  updated: function () {
    // console.log(anime)
    this.findMax()

    anime({
      targets: 'rect',
      duration: 2000,
      fillOpacity: 1
    })
  },
  mounted: function () {
    this.findMax()
  }
}
</script>

<style scoped>
.datavis {
  width: 80%;
  text-align: center;
  height: 150px;
  bottom: 31px;
  position: fixed;
  z-index: 8;
  background: rgb(0,0,0);
  background: linear-gradient(0deg, rgba(0,0,0,1) 44%, rgba(0,0,0,0) 100%);
}

.white {
  background: rgb(239,239,239) !important;
  background: linear-gradient(0deg, rgba(239,239,239,1) 44%, rgba(239,239,239,0) 100%) !important;
}

.graph {
  z-index: 10;
}

.graph__meta {
  width: 600px;
  height: 30px;
  /*background: blue;*/
  position: absolute;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  margin-top: 49px;
}

.graph__metadetail {
  border-top: 1px solid #FF6767;
  font-family: 'fl-mono';
  color: #FF6767;
  font-size: 12px;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 3px;
  position: absolute
}

.grid {
  z-index: -10;
  position: absolute;
  bottom: 0;
  left: 0
}

  rect {
    fill: #707070;
    fill-opacity: 0;
  }

  rect:hover {
    fill: #FF6767;
    cursor: pointer;
  }

  line {
    stroke:#484848;
    stroke-width: 1;
  }

  .grid__number {
    position: absolute;
    left: 0;
    border-top: 1px solid #707070;
    color: #404040;
    font-family: fl-mono;
    font-size: 12px;
    padding-left: 25px;
    padding-right: 10px;
    padding-top: 3px;
  }

  .hundred {
    top: 50px;
  }

  .fifty {
    border-top: 1px solid #484848;
    color: #404040;
    top: 100px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Datavis.vue